import LeaderboardService from '@services/GeniebookAPI/LeaderboardServices.services';
import { useQuery } from '@tanstack/react-query';
import { SLOW_DATA_STALE_TIME_IN_SECONDS } from '@utils/constants/global.constants';

export const useCurrentLeaderboard = () => {
  return useQuery({
    queryKey: ['currentLeaderboard'],
    queryFn: async () => {
      const rawData = await LeaderboardService.getCurrentLeaderboard();
      return rawData.data;
    },
  });
};

export const useLastLeaderboard = (enabled: boolean) => {
  return useQuery({
    queryKey: ['lastLeaderboard'],
    queryFn: async () => {
      const rawData = await LeaderboardService.getLastLeaderboard();
      return rawData.data;
    },
    enabled: enabled,
    staleTime: SLOW_DATA_STALE_TIME_IN_SECONDS * 1000,
  });
};
